/* eslint-disable indent */
import { StreamMessage } from '@modules/contacts/types'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { css, styled } from '@mui/material/styles'
import { colors } from '@theme/variables'

export const Root = styled(Box)`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 400px;
  flex-grow: 1;
`

interface NotificationStatusProps {
  backgroundColor: string
  borderColor: string
}

export const NotificationStatus = styled(Box)`
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 6px 12px;
  background-color: ${({ backgroundColor }: NotificationStatusProps) => backgroundColor};
  border: 1px solid ${({ borderColor }: NotificationStatusProps) => borderColor};
  border-radius: 2px;
`

export const MessageWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 10px;
  &:last-of-type {
    padding-bottom: 16px;
  }
`

export const MessageHeader = styled(Box)`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;

  ${({ $isDisabled }: { $isDisabled: boolean }) =>
    !!$isDisabled &&
    css`
      cursor: auto;
      opacity: 0.2;
      pointer-events: none;
    `}
`

interface MessageAvatarProps {
  avatarSrc: string
}

export const MessageAvatar = styled(Box)`
  width: 46px;
  height: 46px;
  border-radius: 50%;
  background-image: ${({ avatarSrc }: MessageAvatarProps) => `url(${avatarSrc})`};
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;
  flex-shrink: 0;

  ${({ $isDisabled }: { $isDisabled: boolean }) =>
    !!$isDisabled &&
    css`
      cursor: auto;
      opacity: 0.2;
      pointer-events: none;
    `}
`

export const MessageSenderInitials = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  width: 46px;
  height: 46px;
  border-radius: 50%;
  background-color: ${colors.grey};
  color: ${colors.bodyText};
  letter-spacing: -1.6px;
  font-weight: 500;
  text-transform: uppercase;

  ${({ $isDisabled }: { $isDisabled: boolean }) =>
    !!$isDisabled &&
    css`
      cursor: auto;
      opacity: 0.2;
      pointer-events: none;
    `}
`

export const MessageAuthorWrapper = styled('div')`
  display: flex;
  align-items: center;
`

export const MessageHeaderAuthor = styled('div')`
  font-weight: 700;
  margin-right: 5px;
  cursor: pointer;
  color: ${colors.bodyText};
  text-decoration: none;

  ${({ $isDisabled }: { $isDisabled: boolean }) =>
    $isDisabled
      ? css`
          cursor: auto;
          opacity: 0.2;
          pointer-events: none;
        `
      : css`
          &:hover {
            color: ${colors.primary};
          }
        `}
`

interface MessageBoxProps {
  msg: StreamMessage
}

export const MessageBox = styled(Box)`
  padding: 12px;
  border: 1px solid ${({ msg }: MessageBoxProps) => (msg.isMine ? '#E2E2E2' : '#D6D6D6')};
  border-radius: 4px;
  background-color: ${({ msg }: MessageBoxProps) => (msg.isMine ? '#EBFFF2' : '#F8F8F8')};

  ${({ $isDisabled }: { $isDisabled: boolean }) =>
    !!$isDisabled &&
    css`
      cursor: auto;
      opacity: 0.2;
      pointer-events: none;
    `}
`

export const MessageBoxText = styled(Typography)`
  overflow-wrap: break-word;
`

MessageBoxText.defaultProps = { variant: 'body2' }
